import * as React from 'react';
import * as styles from './overlayHeader.scss';

import SVGTransferFailed from 'components/svg/TransferFailed';
import SVGTransferPending from 'components/svg/TransferPending';
import SVGTransferSuccess from 'components/svg/TransferSuccess';

import SVGClose from 'components/svg/Close';
import SVGSaved from 'components/svg/Saved';

type Props = {
    overlayState?: string;
}

const OverlayHeader:React.SFC<Props> = (props) => {
 
    const getOverlayHeader = (overlayStateVal:string='') => {
        switch(overlayStateVal){
            case 'error':
                return  <div className={styles.svgWrapper}>
                            <SVGTransferFailed className={styles.svgDt} /> <SVGClose className={styles.svgMobile + ' ' + styles.svgClose}/>
                        </div>;
            case 'success':
                return  <div className={styles.svgWrapper}>
                            <SVGTransferSuccess className={styles.svgDt}/> <SVGSaved className={styles.svgMobile} />
                        </div>;
            case 'pending':
                return <SVGTransferPending className={styles.svgDt}/>;
            default:
                return <></>;
        }
    }

    return (
        <div className={styles.topWrapper}>
            {getOverlayHeader(props.overlayState)}
        </div>
    );
}

export default OverlayHeader;
